import { Expose, Type } from 'class-transformer'
import { IsDefined, ValidateNested } from 'class-validator'
import { User } from '../../entity'

export class GetUsersDTO {

    @Expose()
    @IsDefined()
    @ValidateNested()
    @Type( type => User )
    users!: User[]

    @Expose()
    @IsDefined()
    pagination!: {
        page: number
        from: number
        to: number
        count: number
    }

}
